<ng-template #template let-row="row">
  <div
    class="project-address-cell"
    [matTooltip]="row?.address ? row?.fullAddress : ''"
    matTooltipPosition="above"
    matTooltipShowDelay="1000"
  >
    {{ row?.address ? row?.fullAddress : '-' }}
  </div>
</ng-template>
